export const EXTERNAL_ATTENDEES_PAGE_SIZE = 5;

export function expandExternalAttendeeBookings(bookings = []) {
  return (Array.isArray(bookings) ? bookings : []).flatMap((booking, bookingIndex) => {
    const names = Array.isArray(booking?.attendeeNames) ? booking.attendeeNames.filter(Boolean) : [];
    if (names.length > 0) {
      return names.map((attendeeName, attendeeIndex) => ({
        ...booking,
        attendeeName,
        rowKey: `${booking.eventSlug || booking.eventName || 'event'}:${booking.occurrenceId || ''}:${bookingIndex}:${attendeeIndex}`,
      }));
    }
    return [{
      ...booking,
      attendeeName: booking?.legacy ? `${booking.purchaserName || 'Account holder'} · legacy booking` : 'Attendee details unavailable',
      rowKey: `${booking?.eventSlug || booking?.eventName || 'event'}:${booking?.occurrenceId || ''}:${bookingIndex}:unknown`,
    }];
  });
}

export function filterExternalAttendees(rows = [], search = '', eventName = '') {
  const needle = String(search || '').trim().toLowerCase();
  return rows.filter(row => {
    if (eventName && row.eventName !== eventName) return false;
    if (!needle) return true;
    return [row.attendeeName, row.purchaserName, row.eventName, row.occurrenceId]
      .some(value => String(value || '').toLowerCase().includes(needle));
  });
}
